/**
 * Converts a JsonLogic object into a {@link index!DefaultRuleGroupType DefaultRuleGroupType}
 * or {@link index!DefaultRuleGroupTypeIC DefaultRuleGroupTypeIC}.
 *
 * @module parseJsonLogic
 */

export * from './parseJsonLogic';
